import React, { Component } from 'react';
import { Trans } from "react-i18next";

import { NavLink } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
//import Swiper from 'react-id-swiper';
import axios from 'axios';
//import Cookies from 'universal-cookie';
import SideBar from "./SideBar";
import SideNav from "react-simple-sidenav";
import "../../config/i18n";
import { withTranslation } from "react-i18next";
import Loader from 'react-loader-spinner';
// import Cookies from 'universal-cookie';

import ls from "local-storage";
import { options } from "../../config/options";

class CibSuccPage extends Component {

    constructor(props) {
        super(props);
        this.loggedIn = sessionStorage.getItem('loggedin');
        this.homeLink = this.homeLink.bind(this);
        this.onChangeSigninemail = this.onChangeSigninemail.bind(this);


        this.receiptPay = this.receiptPay.bind(this);
        this.printreceipt = this.printreceipt.bind(this);

        this.state = {
            wallet_amount: "",
            api_url: localStorage.getItem('api_url'),
            showNav3: false, user_details: '',
            currency_code: "",
            customer_id: "",
            modal4: false,
            lang: ls.get('LangKeySet') || options[0],
            langKey: ls.get('LangValue'),
            take_from_wallet: false,
            payable_amount: 0,
            wallet_detect_amount: 0,
            minus_wallet_amount: 0,
            disabled: false,
            backdrop: true,
            modal6: false,
            email: "",
            errorMail: ""
            // http://localhost:3000/moulookweb/web/app/cibpaymentsucc/premium?orderId=VvZofC0yzL9N5YAAEFXA
        }


    }
    receiptPay() {
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (!pattern.test(this.state.email)) {
            this.setState({
                errorMail: 'Please enter valid email'
            });
        } else {
            this.setState({
                modal4: false,
                backdrop: true
            })
            let data = new FormData();
            data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
            data.append('language', this.state.langKey);
            data.append('package_id', this.state.package_id);
            data.append('purchase_type', this.state.purchase_type);
            data.append('pay_nonce', this.state.pay_nonce);
            data.append('email', this.state.email);
            data.append('approvalcode', this.state.approvalCode);
            data.append('ordernumber', this.state.OrderNumber);
            data.append('respcode_desc', this.state.respCode_desc);

            axios({
                method: 'post',
                url: this.state.api_url + 'receiptmail',
                data: data,
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
            }).then(res => {
                console.log(res);

                this.setState({
                    modal22: true,
                    backdrop: false,
                    message: res.data.message
                })
            });

        }
    }
    printreceipt() {
        // this.setState({
        //     modal4: false,
        //     backdrop: true
        // });

        let data = new FormData();
        data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
        data.append('language', this.state.langKey);
        data.append('package_id', this.state.package_id);
        data.append('purchase_type', this.state.purchase_type);
        data.append('pay_nonce', this.state.pay_nonce);
        data.append('email', this.state.email);
        data.append('approvalcode', this.state.approvalCode);
        data.append('ordernumber', this.state.OrderNumber);
        data.append('respcode_desc', this.state.respCode_desc);

        axios({
            method: 'post',
            url: this.state.api_url + 'generatewebpdf',
            data: data,
            responseType: 'blob', // Specify that the response is a binary file
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
            // Create a blob URL from the binary data
            const url = window.URL.createObjectURL(new Blob([res.data]));

            // Create a temporary anchor element
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'document.pdf');

            // Programmatically click the anchor element to trigger the download
            link.click();

            // Clean up by revoking the blob URL
            window.URL.revokeObjectURL(url);
            //  const baseUrl = window.location.origin;
            //  const redirectUrl = `${baseUrl}/moulook/web/app/Banner`;

            // Redirect the user to the specified URL
            //    window.location.href = redirectUrl;


            // this.setState({
            //     modal22: true,
            //     backdrop: false,
            //     message: "Invoice Downloaded successfully"
            // });
        }).catch(error => {
            console.error('Error downloading PDF:', error);
        });
    }

    printreceipt1() {
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (!pattern.test(this.state.email)) {
            this.setState({
                errorMail: 'Please enter valid email'
            });
        } else {
            this.setState({
                modal4: false,
                backdrop: true
            })
            let data = new FormData();
            data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
            data.append('language', this.state.langKey);
            data.append('package_id', this.state.package_id);
            data.append('purchase_type', this.state.purchase_type);
            data.append('pay_nonce', this.state.pay_nonce);
            data.append('email', this.state.email);
            console.log(this.state.api_url + 'generatewebpdf');

            axios({
                method: 'post',
                url: this.state.api_url + 'generatewebpdf',
                data: data,
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
            }).then(res => {
                console.log(res);

                this.setState({
                    modal22: true,
                    backdrop: false,
                    message: res.data.message
                })
            });

        }
    }
    homeLink() {
        this.setState({
            modal22: false,
            modal4: false,

        })
        if (this.state.purchase_type == 'banner') {
            this.props.history.push("/app/Banner");

        } else {
            this.props.history.push("/app");
            window.location.reload();

        }
    }
    addDefaultSrc(ev) {
        ev.target.src = require('../../assets/img/howzu-logo-default.png')
    }

    closeModal(tabId) {
        this.setState({
            [tabId]: false
        });
        if (tabId == 'modal6') {
            // this.props.history.push("../../Banner"); 
            this.props.history.push("/app/Banner");
        } else {

            this.props.history.push("/app");
            window.location.reload();
        }
    }
    componentDidMount() {
        let purchase_type = this.props.match && this.props.match.params && this.props.match.params.purchase_type;
        // let payment_session_id = this.props.match && this.props.match.params && this.props.match.params.payment_session_id;

        const search = window.location.search;
        const params = new URLSearchParams(search);
        let payment_session_id = params.get('orderId');
        console.log('..............payment_session_id.', payment_session_id)
        var take_from_wallet = JSON.parse(localStorage.getItem('for_cib_payment_take_from_wallet'));
        var payable_amount = JSON.parse(localStorage.getItem('for_cib_payment_payable_amount'));
        var minus_wallet_amount = JSON.parse(localStorage.getItem('for_cib_payment_minus_wallet_amount'));

        var package_id;
        var price;
        var currency;
        var curr_price;
        var api_url;
        if (payment_session_id && purchase_type) {
            if (purchase_type === 'premium') {
                package_id = JSON.parse(localStorage.getItem('selected_premium'));
                price = JSON.parse(localStorage.getItem('premium_price'));
                curr_price = JSON.parse(localStorage.getItem('currency_premium_price'));
                api_url = this.state.api_url + 'cibpaypremium';
            }
            else if (purchase_type === 'boost') {
                package_id = JSON.parse(localStorage.getItem('selected_boostpremium'));
                price = JSON.parse(localStorage.getItem('boostpremium_price'));
                curr_price = JSON.parse(localStorage.getItem('currency_boostpremium_price'));
                api_url = this.state.api_url + 'cibpayboostpremium';
            }
            else if (purchase_type === 'superlike') {
                package_id = JSON.parse(localStorage.getItem('selected_superlikepremium'));
                price = JSON.parse(localStorage.getItem('superlikepremium_price'));
                curr_price = JSON.parse(localStorage.getItem('currency_superlikepremium_price'));
                api_url = this.state.api_url + 'cibpaysuperlikepremium';
            }
            else if (purchase_type === 'banner') {
                package_id = JSON.parse(localStorage.getItem('banner_id'));
                price = JSON.parse(localStorage.getItem('bannerprice'));
                curr_price = JSON.parse(localStorage.getItem('bannerprice'));
                api_url = this.state.api_url + 'cibbannerpayment';
            }

            currency = JSON.parse(localStorage.getItem('currency'));

        }
        this.setState({
            purchase_type: purchase_type,
            package_id: package_id,
            pay_nonce: payment_session_id
        });
        let data = new FormData();
        data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
        data.append('language', this.state.langKey);
        data.append('package_id', package_id);
        data.append('purchase_type', purchase_type);
        data.append('payable_amount', payable_amount);
        data.append('take_from_wallet', take_from_wallet);
        data.append('minus_wallet_amount', minus_wallet_amount);
        data.append('currency_code', currency);
        data.append('pay_nonce', payment_session_id);

        // this.setState({
        //     modal4: true,
        //     backdrop: false,
        //     message: "Amount successfully paid, now your banner is ready to display",
        //     email: "pondurain@appkodes.com"

        // })

        axios({
            method: 'post',
            url: api_url,
            data: data,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
            // console.log(res);return false;



            if (res.data.status !== "false") {

                if (res.data.payment_info) {

                      let respCodeDesc = '';
                if (res.data.payment_info.params && res.data.payment_info.params.respCode_desc) {
                    respCodeDesc = res.data.payment_info.params.respCode_desc;
                } else if (res.data.payment_info.actionCodeDescription) {
                    respCodeDesc = res.data.payment_info.actionCodeDescription;
                }
                
                    this.setState({
                        
                        approvalCode: res.data.payment_info.approvalCode,
                        customer_name:res.data.customer_name,
                        totalCost:res.data.totalCost,
                        product_name:res.data.product_name,
                        currentDate:res.data.currentDate,
                        current_time:res.data.current_time,
                        OrderNumber: res.data.payment_info.OrderNumber,
                        // respCode_desc: res.data.payment_info.params.respCode_desc,
                        respCode_desc: respCodeDesc

                    })

                }

                if (res.data.type == "premium") {
                    this.setState({
                        modal4: true,
                        backdrop: false,
                        message: res.data.message,
                        email: res.data.email
                    })

                    localStorage.setItem('premium_popup', '1');
                }
                // else if (res.data.message == "Amount successfully paid, now your banner is ready to display") {

                //         this.setState({
                //             modal6: true,
                //             backdrop : false,
                //             message: res.data.message,
                //             // email : res.data.email

                //         });

                // }
                else {
                    this.setState({
                        modal4: true,
                        backdrop: false,
                        message: res.data.message,
                        email: res.data.email

                    })
                }
            } else {
                this.setState({
                    modal22: true,
                    backdrop: false,
                    message: res.data.message
                })
            }
        });

    }

    onChangeSigninemail(e) {
        this.setState({
            email: e.target.value
        });
    }
    render() {
        return (
            <>
                {
                    this.state.backdrop === true &&
                    <div class="drop">
                        <div class="loaderrr">
                            <div className="loder-icon">
                                <Loader type="Bars" color="#ca2a1e" height={30} width={50} />
                            </div>
                        </div>
                    </div>
                }

                <div className="setting-page ">


                    <Modal isOpen={this.state.modal22} toggle={this.homeLink} className="premiumPopup vertically-center apd5">
                        <ModalHeader toggle={this.homeLink}><h4 class="modal-title" style={{ 'marginTop': "10px" }}><Trans i18nKey={this.state.message}>{this.state.message}</Trans></h4></ModalHeader>
                        <ModalBody>
                            <div className="modal-body">
                                <div class="d-flex justify-content-end">
                                    <div class="mr-3"><button class="border-0 bg-white pink-color" onClick={this.homeLink}><Trans i18nKey="Ok">Ok</Trans></button></div>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={this.state.modal4} className="premiumPopup vertically-center apd5">
                        <ModalHeader><h4 class="modal-title" style={{ 'marginTop': "10px" }}><Trans i18nKey={this.state.message}>{this.state.message}</Trans></h4></ModalHeader>
                        <ModalBody >
                            <div className="modal-body">
                                <div class="justify-content-center" >
                                  
                                     <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                                    <p ><span style={{ fontWeight: "bold" }}><Trans i18nKey="Customer Name">Customer Name</Trans></span> : <span>{this.state.customer_name}</span></p>
                                    <p ><span style={{ fontWeight: "bold" }}><Trans i18nKey="Email">Email</Trans></span> : <span>{this.state.email}</span></p>
                                    <p ><span style={{ fontWeight: "bold" }}><Trans i18nKey="Product Type">Product Type</Trans></span> : <span>{this.state.purchase_type}</span></p>
                                    <p ><span style={{ fontWeight: "bold" }}><Trans i18nKey="Product Name">Product Name</Trans></span> : <span>{this.state.product_name}</span></p>
                                    <p ><span style={{ fontWeight: "bold" }}><Trans i18nKey="Order Date">Order Date</Trans></span> : <span>{this.state.currentDate}</span></p>
                                    <p ><span style={{ fontWeight: "bold" }}><Trans i18nKey="Time">Time</Trans></span> : <span>{this.state.current_time}</span></p>
                                    <p ><span style={{ fontWeight: "bold" }}><Trans i18nKey="Order Id">Order Id</Trans></span> : <span>{this.state.pay_nonce}</span></p>
                                    <p ><span style={{ fontWeight: "bold" }}><Trans i18nKey="Order Number">Order Number</Trans></span> : <span>{this.state.OrderNumber}</span></p>
                                    <p ><span style={{ fontWeight: "bold" }}><Trans i18nKey="Approval Code">Approval Code</Trans></span> : <span>{this.state.approvalCode}</span></p>
                                    <p ><span style={{ fontWeight: "bold" }}><Trans i18nKey="RespCode_desc">RespCode_desc</Trans></span> : <span>{this.state.respCode_desc}</span></p>
                                    <p ><span style={{ fontWeight: "bold" }}><Trans i18nKey="Merchant site">Merchant site</Trans></span> : <span>https://www.moulook.com</span></p>
                                    <p ><span style={{ fontWeight: "bold" }}><Trans i18nKey="Payment method">Payment method</Trans></span> : <span>CIB/EDAHABIA card</span></p>
                                    <p ><span style={{ fontWeight: "bold" }}><Trans i18nKey="Total">Total</Trans></span> : <span>{this.state.totalCost} DZD</span></p>

                                    </div>
                                      <h5><Trans i18nKey={"Your transaction has been accepted."}>Your payment is accepted</Trans></h5>
                                    <h5><Trans i18nKey={"In the event of a payment problem, please contact the SATIM toll-free number 3020."}>In the event of a payment problem, please contact the SATIM toll-free number 3020.</Trans></h5>
                                    <h5><Trans i18nKey={"Do you want to receive receipt?"}>Do you want to receive receipt?</Trans></h5>

                                    <div className="user-input-wrp amb25">
                                        <br /><br />
                                        <input className="inputText" type="email" id="email" value={this.state.email} onChange={this.onChangeSigninemail} pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$" placeholder=" " required />
                                        <span className="floating-label"><Trans i18nKey="Email">Email</Trans></span>
                                        <p className="text-danger"><Trans i18nKey={this.state.errorMail}>{this.state.errorMail}</Trans></p>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div class=""><button class="border-0 bg-white pink-color" onClick={this.homeLink}><Trans i18nKey="No">No</Trans></button></div>
                                    <div class=""><button class="border-0 bg-white pink-color" onClick={this.printreceipt}><Trans i18nKey="Download Receipt">Download Receipt</Trans></button></div>
                                    <div class="mr-3"><button class="border-0 bg-white pink-color" onClick={this.receiptPay}><Trans i18nKey="Yes">Yes</Trans></button></div>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={this.state.modal6} toggle={this.closeModal.bind(this, 'modal6')} className="premiumPopup vertically-center apd5">
                        <ModalHeader toggle={this.closeModal.bind(this, 'modal6')}><h4 class="modal-title" style={{ 'marginTop': "10px" }}><Trans i18nKey={this.state.message}>{this.state.message}</Trans></h4></ModalHeader>
                        <ModalBody>
                            <div className="modal-body">
                                <div class="d-flex justify-content-end">
                                    <div class="mr-3"><button class="border-0 bg-white pink-color" onClick={this.closeModal.bind(this, 'modal6')}><Trans i18nKey="Ok">Ok</Trans></button></div>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>

                    <div className="sidebarResp d-block d-lg-none">
                        <SideNav showNav={this.state.showNav3} onHideNav={() =>
                            this.setState({ showNav3: false })} title={
                                <div></div>
                            } items={[
                                <SideBar />
                            ]} />
                    </div>
                </div>
            </>
        )
    }
}

export default withTranslation("translations")(CibSuccPage);